customElements.component = 'mmc-video-reviews';

if (!customElements.get(customElements.component)) {
  const selectors = {
    modal: ".js-video-reviews-modal",
    modalInner: ".js-video-reviews-modal-inner",
    modalClose: ".js-video-reviews-modal-close",
    modalVideo: ".js-video-reviews-modal-video",
    slider: ".js-video-reviews-slider",
    videoPreview: ".js-video-reviews-video-preview",
    videoWrap: ".js-video-reviews-video-wrap",
    videoTime: ".js-video-reviews-video-time"
  }

  class MMCVideoReviews extends HTMLElement {
    constructor() {
      super();

      this.html = document.querySelector('html');
      this.modal = this.querySelector(selectors.modal);
      this.modalInner = this.querySelector(selectors.modalInner);
      this.modalClose = this.querySelector(selectors.modalClose);
      this.modalVideo = this.querySelector(selectors.modalVideo);

      this.init();
    }

    openModal() {
      this.modal.classList.add('opened');
      this.html.classList.add('overflow-hidden');
    }

    closeModal() {
      this.modal.classList.remove('opened');
      this.html.classList.remove('overflow-hidden');

      this.modalVideo.setAttribute("src", "");
      this.modalVideo.stop();
    }

    init() {
      const slider = new Swiper(selectors.slider, {
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            allowTouchMove: false
          }
        },
        on: {
          init: () => {
            this.videoPreviews = this.querySelectorAll(selectors.videoPreview);

            this.videoPreviews.forEach(video => {
              const interval = setInterval(() => {
                video.currentTime = 0;
              }, 5000);

              video.addEventListener('click', () => {
                this.modalVideo.setAttribute("src", video.getAttribute("data-video-url"));
                this.modalVideo.play();
                this.openModal();
              });
            });
          }
        },
      });

      this.modal.addEventListener("click", e => {
        if (!this.modalInner.contains(e.target)) {
          this.closeModal();
        }
      })

      this.modalClose.addEventListener("click", () => {
        this.closeModal();
      })
    }
  }

  customElements.define(customElements.component, MMCVideoReviews);
}